<p-toast></p-toast>
<div class="error-tracking">
    <p-card styleClass="p-card-shadow">
        <div class="card dashboardTable">
            <p-toolbar styleClass="mb-4">
                <ng-template pTemplate="left">
                    <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                    class="p-button-success"></button> -->
                    <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
                </ng-template>
                <ng-template pTemplate="right">
                    <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                    <button (click)="menu.toggle($event)" pButton pRipple label="Export" icon="pi pi-upload"
                        class="p-button-help"></button>

                    <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
                    <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}"
                        icon="pi pi-refresh" class="p-button-info ml-3"></button>
                </ng-template>
            </p-toolbar>
            <p-table #miSurvey [value]="errordata" [rows]="15" [paginator]="true" [globalFilterFields]="[
        'AutoID',
        'LoginID',
		'RoleId',
		'ActionType',
		'SpecificId',
		'Status',
		'OccurrenceDateTime',
		'NetworkId',
		'RequestPayload',
        ]" responsiveLayout="scroll" [rowHover]="true"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" [loading]="loading">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'ERROR_TRACKING'| translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <!-- 
                        <th pSortableColumn="AutoID">{{'AUTO_ID'| translate}}
                            <p-columnFilter type="text" field="AutoID" display="menu"></p-columnFilter>
                            <p-sortIcon field="AutoID"></p-sortIcon>
                        </th>
                        <th pSortableColumn="LoginID">{{'LOGIN_ID'| translate}}
                            <p-columnFilter type="text" field="LoginID" display="menu"></p-columnFilter>
                            <p-sortIcon field="LoginID"></p-sortIcon>
                        </th>
                        <th pSortableColumn="RoleId">{{'ROLE_ID'| translate}}
                            <p-columnFilter type="text" field="RoleId" display="menu"></p-columnFilter>
                            <p-sortIcon field="RoleId"></p-sortIcon>
                        </th> -->
                        <th pSortableColumn="ActionType">{{'ACTION_TYPE'| translate}}
                            <p-columnFilter type="text" field="ActionType" display="menu"></p-columnFilter>
                            <p-sortIcon field="ActionType"></p-sortIcon>
                        </th>
                        <th pSortableColumn="SpecificId">{{'SPECIFIC_ID'| translate}}
                            <p-columnFilter type="text" field="SpecificId" display="menu"></p-columnFilter>
                            <p-sortIcon field="SpecificId"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Status">{{'STATUS'| translate}}
                            <p-columnFilter type="text" field="Status" display="menu"></p-columnFilter>
                            <p-sortIcon field="Status"></p-sortIcon>
                        </th>
                        <th pSortableColumn="OccurrenceDateTime">{{'OCCURRANCE_DATE_TIME'| translate}}
                            <p-columnFilter type="text" field="OccurrenceDateTime" display="menu"></p-columnFilter>
                            <p-sortIcon field="OccurrenceDateTime"></p-sortIcon>
                        </th>
                        <!-- <th pSortableColumn="NetworkId">{{'NETWORK_ID'| translate}}
                            <p-columnFilter type="text" field="RemaningQuantity" display="menu"></p-columnFilter>
                            <p-sortIcon field="NetworkId"></p-sortIcon>
                        </th>
                        <th pSortableColumn="RequestPayload">{{'REQUEST_PAYLOAD'| translate}}
                            <p-columnFilter type="text" field="RequestPayload" display="menu"></p-columnFilter>
                            <p-sortIcon field="RequestPayload"></p-sortIcon>
                        </th> -->
                        <th>{{'VIEW'| translate}}</th>
                        <th pSortableColumn="Resolved">{{'RESOLVED'| translate}}
                            <p-columnFilter type="text" field="Resolved" display="menu"></p-columnFilter>
                            <p-sortIcon field="Resolved"></p-sortIcon>
                        </th>
                        <th pSortableColumn="NotRequired">{{'NOT_REQUIRED'| translate}}
                            <p-columnFilter type="text" field="NotRequired" display="menu"></p-columnFilter>
                            <p-sortIcon field="NotRequired"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-errordata>
                    <tr>
                        <!-- <td>{{errordata.AutoID}}</td>
                        <td>{{errordata.LoginID}}</td>
                        <td>{{errordata.RoleId}}</td> -->
                        <td>{{errordata.ActionType}}</td>
                        <td>{{errordata.SpecificId}}</td>
                        <td>{{errordata.Status}}</td>
                        <td>{{errordata.OccurrenceDateTime}}</td>
                        <!-- <td>{{errordata.NetworkId}}</td>
                        <td>{{errordata.RequestPayload}}</td> -->
                        <td><button pButton pRipple pTooltip="View" icon="pi pi-file"
                                class="p-button-rounded p-button-primary p-button-outlined"
                                (click)="showDialog(errordata)"></button>
                        </td>
                        <td>
                            <button *ngIf="errordata.Resolved==0 && errordata.NotRequired==0" pButton pRipple
                                type="button" icon="pi pi-times" (click)="onResolvedClick(errordata)"
                                class="p-button-rounded p-button-danger p-button-outlined"></button>
                            <button *ngIf="errordata.Resolved!=0" pButton pRipple type="button" icon="pi pi-check"
                                (click)="onResolvedClick(errordata)"
                                class="p-button-rounded p-button-success p-button-outlined"></button>
                        </td>
                        <td>
                            <button *ngIf="errordata.NotRequired==0 && errordata.Resolved==0" pButton pRipple
                                type="button" icon="pi pi-times" (click)="onNotRequiredClick(errordata)"
                                class="p-button-rounded p-button-danger p-button-outlined"></button>
                            <button *ngIf="errordata.NotRequired!=0" pButton pRipple type="button" icon="pi pi-check"
                                (click)="onNotRequiredClick(errordata)"
                                class="p-button-rounded p-button-success p-button-outlined"></button>
                        </td>
                    </tr>
                </ng-template>

            </p-table>
        </div>
    </p-card>
</div>
<!-- <p-button (click)="showDialog()" icon="pi pi-external-link" label="Show"></p-button> -->
<p-dialog id="ping" header="Error Details" [(visible)]="visible" [style]="{ width: '80%', height: '70%' ,fontWeight:'bold'}" [maximizable]="true" [draggable]="false" [resizable]="false"
[baseZIndex]="-100" (onHide)="onCloseDialog()">

    <div class="p-fluid p-formgrid grid justify-content-center my-2 error-details card">
        <div class="field col-12 md:col-6" >
            <label>{{'AUTO_ID'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ selectedData?.AutoID
                    }}</label></label>
        </div>

        <div class="field col-12 md:col-6">
            <label>{{'LOGIN_ID'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ selectedData?.LoginID
                    }}</label></label>
        </div>

        <div class="field col-12 md:col-6">
            <label>{{'ROLE_ID'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ selectedData?.RoleId
                    }}</label></label>
        </div>

        <div class="field col-12 md:col-6">
            <label>{{'ACTION_TYPE'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{
                    selectedData?.ActionType
                    }}</label></label>
        </div>

        <div class="field col-12 md:col-6">
            <label>{{'SPECIFIC_ID'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{
                    selectedData?.SpecificId
                    }}</label></label>
        </div>

        <div class="field col-12 md:col-6">
            <label>{{'STATUS'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ selectedData?.Status
                    }}</label></label>
        </div>

        <div class="field col-12 md:col-6">
            <label>{{'OCCURRANCE_DATE_TIME'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{
                    selectedData?.OccurrenceDateTime
                    }}</label></label>
        </div>

        <div class="field col-12 md:col-6">
            <label>{{'NETWORK_ID'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{
                    selectedData?.NetworkId
                    }}</label></label>
        </div>

        <div class="field col-12 md:col-12">
            <label>{{'REQUEST_PAYLOAD'| translate}}: </label>
            <textarea rows="8" cols="30" pInputTextarea [disabled]="true" style="min-width: 157px;color: black;opacity: 1;">{{ selectedData?.RequestPayload }}</textarea>
        </div>
    </div>

</p-dialog>

<p-confirmDialog [style]="{width: '30vw'}"></p-confirmDialog>